
import { defineComponent, ref, reactive } from 'vue'
import { getGeoArea, getPriceList, editPrice } from '@/service/main/system/system'
import { ElMessage } from 'element-plus'

export default defineComponent({
  name: 'price',
  components: {
  },
  setup() {
    const areaValue = ref('')
    const geoAreaList = ref<any[]>([])
    const areaInfo = ref<any>({
      province: '',
      city: ''
    })
    const priceList = ref<any[]>([])
    const dialogVisible = ref(false)
    const formRef = ref<any>(null)
    
          // 表单数据
      const formData = reactive({
        id: '',
        province: '',
        city: '',
        price: 0, // 使用数字类型
        levelKey: '',
        gradeKey: ''
      })

    // 表单校验规则
    const rules = {
      province: [{ required: true, message: '请输入省份', trigger: 'blur' }],
      city: [{ required: true, message: '请输入城市', trigger: 'blur' }],
      price: [
        { required: true, message: '请输入价格', trigger: 'blur' },
        { type: 'number', message: '价格必须为数字', trigger: 'blur' }
      ]
    }
   
    const getGeoAreaList = async () => {
      const res: any = await getGeoArea('/app/area/getAreaTree', {
        type: 2
      })
      geoAreaList.value = res?.data
      if(geoAreaList.value.length > 0 && geoAreaList.value[0].child.length > 0) {
        // 默认选择第一个城市
        areaValue.value = geoAreaList.value[0].child[0].id
        areaInfo.value.province = geoAreaList.value[0].name
        areaInfo.value.city = geoAreaList.value[0].child[0].name
        getList()
      }
    }
    
    const handleAreaChange = (value: string) => {
      // 找到对应的省市信息
      for (const province of geoAreaList.value) {
        for (const city of province.child) {
          if (city.id === value) {
            areaInfo.value.province = province.name
            areaInfo.value.city = city.name
          }
        }
      }
    }
    
    getGeoAreaList()
    const getList = async () => {
      const res: any = await getPriceList('/pc/price/list', areaInfo.value)
      priceList.value = res?.data
    }

    // 处理关闭弹窗
    const handleDialogClose = () => {
      dialogVisible.value = false
      // 重置表单内容
      formRef.value?.resetFields()
      Object.assign(formData, {
        id: '',
        province: '',
        city: '',
        price: 0, // 重置为数字类型
        levelKey: '',
        gradeKey: ''
      })
    }

    // 打开编辑弹窗
    const handleEdit = (row: any,parentRow: any) => {
      dialogVisible.value = true
              // 填充表单数据
        Object.assign(formData, {
          id: row.id,
          province: row.province,
          city: row.city,
          price: row.price / 100, // 将分转换为元显示
          levelKey: parentRow.levelKey,
          gradeKey: row.gradeKey
        })
    }

          // 确认编辑
      const handleConfirm = () => {
        formRef.value?.validate(async (valid: boolean) => {
          if (valid) {
            try {
              // 构造提交数据，价格从元转换回分
              const submitData = {
                ...formData,
                price: Math.round(formData.price * 100) // 将元转换回分
              }
              const res: any = await editPrice('/pc/price/edit', submitData)
                ElMessage.success('价格修改成功')
              handleDialogClose()
              // 刷新表格数据
              getList()
          } catch (error) {
            ElMessage.error('价格修改失败')
            console.error(error)
          }
        }
      })
    }

    return {
      geoAreaList,
      areaValue,
      areaInfo,
      priceList,
      dialogVisible,
      formData,
      rules,
      formRef,
      handleAreaChange,
      getList,
      handleEdit,
      handleDialogClose,
      handleConfirm
    }
  }
})
